import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
    selector: "web-terms-and-conditions",
    templateUrl: "./terms-and-conditions.component.html",
    styleUrls: ["./terms-and-conditions.component.scss"],
})
export class TermsAndConditionsComponent {
    link!: SafeResourceUrl;
    constructor(
        public dialogRef: MatDialogRef<TermsAndConditionsComponent>,
        private sanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
    ngOnInit() {
        this.link = this.sanitizer.bypassSecurityTrustResourceUrl(this.data);
    }
    closeDialog() {
        this.dialogRef.close({
            success: true,
        });
    }
}
